import { render, staticRenderFns } from "./HrBasicOrgTemp.vue?vue&type=template&id=0c99a09e&scoped=true&"
import script from "./HrBasicOrgTemp.vue?vue&type=script&lang=js&"
export * from "./HrBasicOrgTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99a09e",
  null
  
)

export default component.exports